import { AxiosResponse } from "axios";

import API from "../api";

import { Mail } from "../models/mail";

const ROUTE_NAME = "email";

const EmailService = {
  async send(mail: Mail): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}`, mail);
  },
};

export default EmailService;
